declare global {
    interface Window {
      dataLayer: Record<string, any>[];
      gtag: (...args: any[]) => void;
    }
  }
  
  export function gtag(...args: any[]) {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag(...args);
    }
  }
  
  export function pageview(path: string) {
    gtag("event", "page_view", { page_path: path });
  }
  
  export function trackEvent(action: string, params?: Record<string, any>) {
    gtag("event", action, params);
  }
  
  // --- Event Names ---
  export const GA_EVENTS = {
    BUTTON_CLICK: "button_click",
    FORM_SUBMIT: "form_submit",
    PAGE_SCROLL: "page_scroll",
    VIDEO_PLAY: "video_play",
    PAGE_VIEW: "page_view",
  } as const;
  
  // --- Typed Enums for Labels ---
  export enum ButtonLabels {
    HERO_CTA = "hero_cta",
    SIGNUP_FORM = "signup_form",
    SUBSCRIBE_NEWSLETTER = "subscribe_newsletter",
    PLAY_VIDEO = "play_video",
  }
  
  export enum FormLabels {
    NEWSLETTER_SIGNUP = "newsletter_signup",
    CONTACT_US = "contact_us",
    CHECKOUT = "checkout",
  }
  

  // --- Helper Functions ---
  export function trackButtonClick(
    label: ButtonLabels,
    additionalParams?: Record<string, any>
  ) {
    trackEvent(GA_EVENTS.BUTTON_CLICK, {
      label,
      page_path: window.location.pathname,
      ...additionalParams,
    });
  }
  
  export function trackFormSubmit(
    formName: FormLabels,
    additionalParams?: Record<string, any>
  ) {
    trackEvent(GA_EVENTS.FORM_SUBMIT, {
      form_name: formName,
      page_path: window.location.pathname,
      ...additionalParams,
    });
  }
  
  export function trackScroll(depthPercent: number) {
    trackEvent(GA_EVENTS.PAGE_SCROLL, {
      depth_percent: depthPercent,
      page_path: window.location.pathname,
    });
  }
  
  export function trackVideo(videoTitle: string, action: "play" | "pause" | "complete") {
    trackEvent(GA_EVENTS.VIDEO_PLAY, {
      video_title: videoTitle,
      video_action: action,
      page_path: window.location.pathname,
    });
  }
  